import { render, staticRenderFns } from "./ExpressList.vue?vue&type=template&id=1a65e59a&scoped=true"
import script from "./ExpressList.vue?vue&type=script&lang=js"
export * from "./ExpressList.vue?vue&type=script&lang=js"
import style0 from "./ExpressList.vue?vue&type=style&index=0&id=1a65e59a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a65e59a",
  null
  
)

export default component.exports